export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "/content/Views/visualizers/js/features.worker.min.js");
}
